import { GoogleLogo, Lightning } from "@phosphor-icons/react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const startLogin = () => {
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export default function Login() {
    return (
        <div className="min-h-screen bg-white flex">
            {/* LEFT — brutalist hero */}
            <div className="hidden lg:flex flex-col justify-between w-[46%] bg-ink text-white p-14 relative overflow-hidden">
                <div className="relative z-10">
                    <div className="flex items-center gap-2">
                        <div className="w-3 h-3 bg-klein" />
                        <span className="font-mono uppercase tracking-widest text-[10px] font-bold text-neutral-400">
                            // serp scout · internal
                        </span>
                    </div>
                    <h1 className="mt-10 font-display font-black tracking-tighter text-5xl xl:text-6xl leading-[0.95]">
                        Rival<br />
                        Recon<br />
                        <span className="text-klein">On Autopilot.</span>
                    </h1>
                    <p className="mt-6 text-neutral-400 text-sm max-w-md leading-relaxed">
                        Competitor SERP scraping, ad-copy synthesis, campaign builder exports,
                        location + search-term auditing — every tool your agency uses, one login away.
                    </p>
                </div>

                <div className="relative z-10 flex gap-8 text-xs font-mono uppercase tracking-widest text-neutral-500">
                    <div>
                        <div className="text-white text-2xl font-black tracking-tight">05</div>
                        modules
                    </div>
                    <div>
                        <div className="text-white text-2xl font-black tracking-tight">∞</div>
                        exports
                    </div>
                    <div>
                        <div className="text-white text-2xl font-black tracking-tight">01</div>
                        team
                    </div>
                </div>

                {/* Decorative bar strip */}
                <div className="absolute right-0 top-0 bottom-0 w-2 flex flex-col">
                    {Array.from({ length: 12 }).map((_, i) => (
                        <div
                            key={i}
                            className={`flex-1 ${i % 3 === 0 ? "bg-klein" : "bg-neutral-800"}`}
                        />
                    ))}
                </div>
            </div>

            {/* RIGHT — sign in */}
            <div className="flex-1 flex flex-col justify-center px-8 lg:px-24 xl:px-40">
                <div className="max-w-md">
                    <div className="flex items-center gap-2 mb-8">
                        <Lightning size={14} weight="bold" className="text-klein" />
                        <span className="font-mono uppercase tracking-widest text-[10px] font-bold text-neutral-500">
                            // sign in required
                        </span>
                    </div>

                    <h2 className="font-display text-4xl font-black tracking-tighter text-ink">
                        Welcome back.
                    </h2>
                    <p className="mt-3 text-neutral-600 text-sm leading-relaxed">
                        This is an internal Google Ads research tool. Sign in with the Google account
                        your team has been granted access to.
                    </p>

                    <button
                        data-testid="btn-google-signin"
                        onClick={startLogin}
                        className="mt-10 w-full h-12 flex items-center justify-center gap-3 border-2 border-ink bg-ink text-white font-mono uppercase tracking-widest text-xs font-bold hover:bg-white hover:text-ink transition-all"
                    >
                        <GoogleLogo size={18} weight="bold" />
                        Continue with Google
                    </button>

                    <div className="mt-6 flex items-start gap-2 text-[11px] text-neutral-500">
                        <div className="w-1 h-1 bg-klein rounded-full mt-1.5 shrink-0" />
                        <span>
                            Sessions last 7 days. Everything you build stays inside this workspace —
                            no data leaves the box.
                        </span>
                    </div>
                </div>

                <div className="mt-16 font-mono text-[10px] uppercase tracking-widest text-neutral-400">
                    © SERP Scout · Internal use only
                </div>
            </div>
        </div>
    );
}
